module.exports = __webpack_public_path__ + "static/media/garage_002.e9f49d1c.png";